import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { login } from "../../actions/authAction";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

// import {
//     Card,
//     Form,
//     FormGroup,
//     FormFeedback,
//     Input,
//     Button,
//     Row,
//     Col
// } from "reactstrap";

import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'

class LoginPage extends Component {
    constructor() {
        super();
        this.state = {
            userEmail: '',
            password: '',
            errors: {}
        };
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push('/dashboard');
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            this.props.history.push('/dashboard');
        }

        if (nextProps.errors) {
            console.log("===============Errors bad data==================" + JSON.stringify(nextProps.errors))
            this.setState({ errors: nextProps.errors });
        }
    }

    onChange = e =>
        this.setState({
            [e.target.name]: e.target.value
        });

    onSubmit = e => {
        e.preventDefault();

        const userData = {
            userEmail: this.state.userEmail,
            password: this.state.password
        };

        this.props
            .login(userData)
    };

    loginToStore = e => {
        this.props.location.pathname = '/store';
        this.onSubmit(e);
    }
    render() {
        const { errors } = this.state;
        const invalid = Object.keys(errors).length > 0 && true;
        const { success, notActive } = this.props.auth;

        let credence_error = <div style={{ marginBottom: "5px", color: "red" }}>Bad Credentials</div>
        return (
            <div className="container" style={{ width: "100%" }}>
                {success && <Message
                    success
                    header="Password changed"
                    content="Please login again to continue."
                />}
                {notActive && <Message
                    danger
                    header="Access Denied"
                    content="Your account has been de-activated. Please contact administrator for more dtails. "
                />}

                <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Form size='large'>

                            <Segment.Group>
                                <Segment><Header as='h2' color='teal' textAlign='center'>
                                    {/* <Image className="mx-2" style={{ width: 50 }} src={require("../../assets/img/logo_login.png")} alt="" /> */}
                                    <span>TeleRx</span>
                                </Header></Segment>
                                <Segment >
                                    {invalid ? credence_error : <span></span>}
                                    <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address'
                                        invalid={invalid}
                                        type="email"
                                        name="userEmail"
                                        value={this.state.userEmail}
                                        error={invalid}

                                        onChange={this.onChange}
                                        required />
                                    <Form.Input
                                        fluid
                                        icon='lock'
                                        iconPosition='left'
                                        placeholder='Password'
                                        type='password'

                                        invalid={invalid}
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.onChange}
                                        required
                                        error={invalid}
                                    />

                                    <Button color='teal' fluid size='large' onClick={this.onSubmit}>
                                        Login
                                    </Button></Segment>
                                <Segment attached="bottom">
                                    <Link to='store' onClick={this.loginToStore}>
                                        <span style={{ fontWeight: "bolder" }}  ><i class="fas fa-headset fa-2x mx-2" style={{ color: "red" }}></i>Login to Counselling Screen</span>
                                    </Link>
                                </Segment>
                            </Segment.Group>
                            <Link to="forgot-password">
                                <span style={{ textDecoration: "underline" }}>Forgot Password</span>
                            </Link>
                        </Form>
                        {/* <Message>
                        New to us? <a href='#'>Sign Up</a>
                    </Message> */}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}
LoginPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    login: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps, { login })(withRouter(LoginPage));
